import {
  createCharMeasure,
  measureTextWidthMm,
} from "../../layout/fontWidthData";
import { mmToDots } from "../../utils/units";
import type { PreparedTextElement, TextEngineContext } from "./types";

function alignedXDots(
  prepared: PreparedTextElement,
  line: string,
  ctx: TextEngineContext,
  measure: (char: string) => number,
): number {
  if (prepared.align === "L") {
    return prepared.xDots;
  }

  const measuredDots = mmToDots(
    measureTextWidthMm(line, prepared.family, prepared.fontWidthMm, measure),
    ctx.renderContext.dpi,
  );
  const slack = Math.max(0, prepared.widthDots - measuredDots);

  if (prepared.align === "C") {
    return prepared.xDots + Math.floor(slack / 2);
  }

  return prepared.xDots + slack;
}

export function emitWithLineSafeEngine(
  prepared: PreparedTextElement,
  ctx: TextEngineContext,
): void {
  const stepDots = prepared.fontHeightDots + prepared.lineSpacingDots;
  const visibleLines = prepared.lines.slice(0, Math.max(1, prepared.maxLines));
  const measure = createCharMeasure(prepared.family, prepared.fontWidthMm);

  visibleLines.forEach((line, index) => {
    const y = prepared.yDots + index * stepDots;
    const x = alignedXDots(prepared, line, ctx, measure);
    const fieldData = ctx.prepareFieldData(line, ctx.encoding);

    ctx.zpl.push(`^FO${x},${y}`);
    ctx.zpl.push(
      `^A${prepared.family}N,${prepared.fontHeightDots},${prepared.fontWidthDots}`,
    );
    if (prepared.reversePrint) {
      ctx.zpl.push("^FR");
    }
    if (fieldData.useHex) {
      ctx.zpl.push("^FH_");
    }
    ctx.zpl.push(`^FD${fieldData.text}`);
    ctx.zpl.push("^FS");
  });

  ctx.textDiagnostics.push({
    elementId: prepared.positioned.element.id,
    selectedEngine: "line-safe",
    wrapStrategy: "line-safe",
    lineCount: visibleLines.length,
    clipped: prepared.positioned.textOverflowed === true,
    ellipsized: prepared.positioned.textEllipsized === true,
    profileSource: "per-char",
  });
}
